<template>
  <div>
    <div>
      <p class="title">ДОГОВОР №{{ doc_id }}</p>
      <p class="subtitle">оказания услуг перевозки грузов</p>
      <div style="display: flex; justify-content: space-between">
        <div>Город {{ getCity(doc.org1) }}</div>
        <div>&laquo;{{ day }}&raquo; {{ month }} {{ year }} г.</div>
      </div>
      <p style="text-align: justify">
        {{ doc.org2.organizations.org_type }} &laquo;{{
          doc.org2.organizations.org_name
        }}&raquo;, зарегистрированное по адресу:
        {{ getOrganizationAddress(doc.org2) }}, именуемое в дальнейшем
        «Продавец» в лице {{ doc.org1.organizations.company_ceo }}, действующего
        на основании Устава, с одной стороны, и
        {{ doc.org1.organizations.org_type }} &laquo;{{
          doc.org1.organizations.org_name
        }}&raquo;, зарегистрированное по адресу:
        {{ getOrganizationAddress(doc.org1) }}, именуемое в дальнейшем
        «Покупатель», в лице {{ doc.org2.organizations.company_ceo }},
        действующего на основании Устава, с другой стороны, далее совместно
        именуемые «Стороны», подписали настоящий Контракт (далее – «Контракт») о
        нижеследующем.
      </p>
      <p class="subtitle">1. Предмет договора</p>
      <p style="text-align: justify">
        1.1. По настоящему договору Исполнитель обязуется доставить вверенный
        ему отправителем груз в пункт назначения и выдать его уполномоченному
        лицу (получателю) без удержаний, а Клиент обязуется уплатить за
        перевозку груза согласованную плату.
      </p>
      <p>
        1.2. Подробные сведения и условия по каждой отдельной перевозке
        согласуются сторонами в Заявке, которая является неотъемлемой частью к
        данному Договору. Подписанная и заверенная печатями обеих сторон Заявка,
        переданная по электронной почте, имеет юридическую силу.
      </p>
      <p style="text-align: justify">
        1.3. Отношения сторон регулируются настоящим договором,
        законодательством Республики Казахстан, Конвенцией о договоре
        международной дорожной перевозки грузов (КДПГ), другими нормами
        международного права, применимыми к отношениям сторон в силу
        содержащихся в них указаний.
      </p>
      <p style="text-align: justify">
        1.4. Прием грузов от Клиента осуществляется Исполнителем на основании
        товарно-транспортной накладной и сопроводительных документов на груз.
      </p>
      <p style="text-align: justify">
        1.5. Исполнитель вправе привлекать для исполнения настоящего договора
        третьих лиц, при этом возложение исполнения обязательства на третье лицо
        не освобождает Перевозчика от ответственности перед Клиентом за
        выполнение условий настоящего договора.
      </p>
      <p class="subtitle">2. Порядок оформления Заявки на перевозку.</p>
      <p style="text-align: justify">
        2.1. На осуществление каждой отдельной перевозки Клиент предоставляет
        Перевозчику заявку на перевозку (далее по тексту – «заявка»). Заявка
        содержит специальные требования для каждой отдельной перевозки и
        является неотъемлемой частью настоящего договора. Условия, оговоренные в
        заявке, имеют приоритетное значение по отношению к условиям настоящего
        договора.
      </p>
      <p style="text-align: justify">
        2.2. Заявка направляется посредством факсимильной связи или e-mail.
        Заявка может быть отменена Клиентом либо Перевозчиком в одностороннем
        порядке без оплаты штрафов, но не менее чем за
        {{ doc.cancel_term }} часов (исключая выходные и праздничные дни) до
        согласованного времени прибытия транспортного средства Перевозчика под
        загрузку.
      </p>
      <p style="text-align: justify">
        2.3. Перевозчик обязан в течение {{ doc.consent_term }} часов с момента
        получения заявки сообщить о своем согласии или несогласии выполнить
        перевозку на предложенных условиях.
      </p>
      <p class="subtitle">3. Права и обязанности Сторон</p>
      <p>
        <strong> 3.1. Исполнитель обязан: </strong>
      </p>
      <p style="text-align: justify">
        3.1.1. После получения Заявки предоставить под погрузку автотранспортное
        средство в технически исправном состоянии, пригодном для перевозки
        заявленного груза в согласованные с Клиентом сроки.
      </p>
      <p style="text-align: justify">
        3.1.2. Организовать доставку груза, наименование, количество, вес и
        объем которого указывается в Заявке к настоящему договору.
      </p>
      <p style="text-align: justify">
        3.1.3. Проинформировать Клиента в течение {{ doc.inform_term }} часов
        обо всех случаях вынужденной задержки автомашины в пути, их причинах и
        других непредвиденных обстоятельствах, препятствующих своевременной
        погрузке.
      </p>
      <p style="text-align: justify">
        3.1.4. Предоставлять информацию Клиенту о местонахождении автомашины с
        грузом по всему пути следования каждые {{ doc.location_term }} часа с
        момента загрузки, информация может быть предоставлена как
        телефонограммой, так и в письменном виде.
      </p>
      <p style="text-align: justify">
        3.1.5. В случае поломки транспортного средства или ДТП, Исполнитель
        вправе не дожидаясь согласия Клиента, но в интересах Клиента,
        перегрузить груз на другое транспортное средство.
      </p>
      <p style="text-align: justify">
        3.1.6. Исполнитель обязан сообщать Клиенту обо всех обнаруженных
        недостатках полученной информации о грузе и условиях его доставки, а в
        случае ее неполноты произвести дополнительный запрос. Ответ на
        дополнительный запрос должен быть получен в течение 24 часов с момента
        запроса дополнительных сведений. В случае если Клиент не предоставляет
        дополнительную информацию в указанный срок, Исполнитель не несет
        ответственность за полноту информации и достоверность документов.
      </p>
      <p style="text-align: justify">
        3.1.7. Водитель присутствует при погрузке и опломбировании грузового
        отсека автотранспортного средства и участвует в креплении груза согласно
        п.3.3.5 Договора. Водитель не принимает участие в перевесах и пересчетах
        грузов, прибывших в исправных автотранспортных средствах, отдельных
        секциях грузового автомобиля, контейнерах и цистернах с неповрежденными
        пломбами грузоотправителя, а также в исправной обандероленной таре,
        которые выдаются Получателю без проверки веса и состояния груза и
        количества грузовых мест.
      </p>
      <p style="text-align: justify">
        3.1.8. Исполнитель обязан проверить точность указаний сделанных в
        накладной относительно числа грузовых мест, а также их разметки,
        нумерации и внешнего состояния груза. Если Исполнитель не имеет
        достаточной возможности проверить правильность сведений, он должен
        сделать отметку/ оговорку в сопроводительных документах.
      </p>
      <p style="text-align: justify">
        3.1.9. Исполнитель выдает груз в пункте назначения Получателю,
        указанному в сопроводительных документах (ТТН, СМР, Инвойс).
      </p>
      <p style="text-align: justify">
        3.1.10. Проверка правильности и полноты сопроводительных документов не
        лежит на ответственности Исполнителя. Отправитель ответственен перед
        Исполнителем за всякий ущерб, который может быть причинен отсутствием,
        недостаточностью или неправильностью этих документов или сведений.
      </p>
      <p style="text-align: justify">
        3.1.11. Исполнитель принимает груз по количеству грузовых мест, по
        целостности наружной упаковки и не несет ответственность за состояние
        груза внутри упаковки, при условии соблюдения целостности упаковки при
        перевозке.
      </p>
      <p style="text-align: justify">
        3.1.12. Исполнитель обязан требовать документального оформления
        процессуальных действий с грузом от контролирующих органов. В случаях
        изъятия любого количества груза получать от соответствующих органов
        документы о факте изъятия и немедленно информировать в письменном виде
        об этом Заказчика.
      </p>
      <p style="text-align: justify">
        3.1.13. При возникновении страхового случая (кража, порча и т.п.)
        Исполнитель обязан немедленно уведомить Заказчика в письменном виде, а
        также выслать по электронной почте копию заявления, направленного в
        страховую компанию о наступлении страхового случая. Обеспечить скорейшее
        предоставление официальных документов, подтверждающих наступление
        страхового случая.
      </p>
      <p style="text-align: justify">
        3.1.14. Исполнитель обязан неукоснительно соблюдать требования Заказчика
        касающиеся сохранности доставляемого груза.
      </p>
      <p>
        <strong> 3.2. Исполнитель вправе: </strong>
      </p>
      <p style="text-align: justify">
        3.2.1. Отказаться от запланированной перевозке, если данные по грузу не
        соответствуют первоначальным данным, ранее оговоренным в Заявке к
        настоящему договору.
      </p>
      <p style="text-align: justify">
        3.2.2. Исполнитель вправе привлекать для исполнения настоящего договора
        третьих лиц. При этом возложение исполнения обязательства на третье лицо
        не освобождает Перевозчика от ответственности перед Клиентом за
        выполнение условий настоящего договора, заключив с ним соглашение о
        конфиденциальности.
      </p>
      <p style="text-align: justify">
        3.2.3. Произвести перерасчет стоимости фрахта:
      </p>
      <ul>
        <li>
          в случае, если первоначальные данные о перевозке будут изменены
          Клиентом в сторону увеличения затрат на перевозку;
        </li>
        <li>
          в случае, если стоимость ДТ увеличится более чем на
          {{ doc.fuel_percent }}%;
        </li>
        <li>
          в случае, если произойдет поднятие курса валюты более чем на
          {{ doc.currency_percent }}%;
        </li>
        <li>
          в случае, если специфика перевозки будет изменена от заявленной
          (санкционный груз, опасный груз, конвойный груз, негабаритный груз).
        </li>
      </ul>
      <p style="text-align: justify">
        3.2.4. Исполнитель имеет право на возмещение расходов, вызванных
        просьбой или выполнением полученных инструкций от Клиента.
      </p>
      <p>
        <strong> 3.3. Клиент обязан: </strong>
      </p>
      <p style="text-align: justify">
        3.3.1. Подать Исполнителю письменную заявку на подачу автомашины под
        погрузку не позднее, чем за {{ doc.application_term }} часов до ее
        начала. Заявка подается в письменном виде с предоставлением полной и
        всесторонней информацией, касающуюся сведений груза, необходимых для
        надлежащего исполнения перевозки (стоимость фрахта, маршрут перевозки,
        наименование груза, вес груза, место погрузки и разгрузки, адреса и
        телефоны контактных лиц, особые свойства груза, стоимость груза и т.д.).
        В случае предоставления недостоверных сведений препятствующий
        надлежащему исполнению перевозки, Клиент возмещает Исполнителю
        обоснованные документально понесенные им расходы.
      </p>
      <p style="text-align: justify">
        3.3.2. Заблаговременно до начала перевозки обязан предоставить
        Исполнителю документы на груз, требуемых в процессе перевозки.
      </p>
      <p style="text-align: justify">
        3.3.3. Предоставить к перевозке груз согласно номенклатуре и в
        количестве, указанных в Заявке, в таре и упаковке, обеспечивающих их
        сохранность.
      </p>
      <p style="text-align: justify">
        3.3.4. Клиент до прибытия грузового автомобиля под погрузку должен
        подготовить груз к перевозке (поместить в тару, упаковать, сгруппировать
        по грузополучателям), подготовить товарно-транспортную накладную и
        сопроводительные документы, а в случае необходимости - пропуски на право
        проезда к месту погрузки грузов. Груз сдается Клиентом к перевозке в
        упакованном, затаренном, опломбированном, промаркированном виде с
        указанием количества, точного веса (объема). Упаковка сдаваемого к
        перевозке груза не должна иметь нарушений целостности или следов
        повреждения груза (подтеки, разрывы, вмятины и так далее).
      </p>
      <p style="text-align: justify">
        3.3.5. Груз должен быть уложен в автотранспортном средстве и надежно
        закреплен вместе с водителем Исполнителя так, чтобы не было сдвига,
        падения, давления на двери, потертости или повреждения груза при
        перевозке, а также обеспечивалась сохранность автотранспортных средств
        при погрузке, разгрузке и в пути следования.
      </p>
      <p style="text-align: justify">
        3.3.6. Погрузка грузов на автотранспортное средство, закрепление,
        укрытие и увязка грузов, а также необходимые для погрузки и перевозки
        приспособления, вспомогательные материалы (козлы, стойки, лотки,
        проволока, щитовые ограждения и так далее), а также средства,
        необходимые для утепления грузов (одеяла, маты и так далее)
        предоставляется, устанавливается, и производятся Клиентом, а разгрузка
        грузов, снятие креплений и покрытий – Получателем.
      </p>
      <p style="text-align: justify">
        3.3.7. Произвести таможенное оформление и разгрузочные работы в течение
        {{ doc.customs_term }} часов с момента прибытия транспорта к указанному
        в заявке месту разгрузки.
      </p>
      <p style="text-align: justify">
        3.3.8. Своевременно и в полном объеме производить расчеты с
        Исполнителем, при условии отсутствия претензий к Исполнителю.
      </p>
      <p style="text-align: justify">
        3.3.9. Обеспечить технику безопасности на месте погрузки и разгрузки
        Груза.
      </p>
      <p style="text-align: justify">
        3.3.10. Предоставить в письменном виде информацию Получателю груза и
        Исполнителю о размещении груза при его погрузке.
      </p>
      <p style="text-align: justify">
        3.3.11. Принять и осмотреть груз в соответствии с требованиями
        законодательства, предусмотренные для данного вида транспорта. В случае
        обнаружения каких – либо недостатков немедленно приостановить разгрузку
        транспортного средства, вызвать на место выгрузки представителей
        Исполнителя, вызвать представителей страховой компании, составить
        коммерческий акт установленной формы, сделать отметки в CMR и иных
        товарно-транспортных накладных. В случае неисполнения Клиентом
        установленной данным пунктом обязанности, констатируется что это сделано
        для им для сокрытия своих нарушений, законодательства и условий
        договора, а груз считается принятым, в надлежащем состоянии и
        количестве, указанном в сопроводительных документах, и согласованные
        сроки.
      </p>
      <p class="subtitle">4. Условия платежа</p>
      <p>
        4.1. Оплата за выполненные транспортные услуги производится в тенге в
        соответствии с согласованными в Заявке ставками и условиями, на
        основании выставленного Исполнителем счета.
      </p>
      <p style="text-align: justify">
        4.2. Исполнитель выставляет счет на оплату суммы, указанной в Заявке.
      </p>
      <p style="text-align: justify">
        4.3. Клиент обязан произвести оплату в течение ___ (___________) рабочих
        дней после разгрузки автомашины, получения оригиналов бухгалтерских (акт
        выполненных работ, электронная счет-фактура) и товара-транспортных (ТТН,
        ТН, СМR) документов)
      </p>
      <p style="text-align: justify">
        4.4. При взаиморасчетах Клиент оплачивает банковские услуги за денежный
        перевод.
      </p>
      <p style="text-align: justify">
        4.5. Сверхнормативные простои транспортных средств, произошедшие по вине
        Клиента, оплачиваются им Исполнителю в течение 7 (семи) банковских дней
        после доставки груза, по ставкам, указанным в подпункте 4.1. настоящего
        Договора.
      </p>
      <p style="text-align: justify">
        4.6. Оплата за временное хранение груза на СВХ производится Клиентом.
      </p>
      <p style="text-align: justify">
        4.7. В случае несоответствия данных, предоставленных в Заявке,
        фактическим данным: перегруза, негабарита и дополнительного пробега,
        Клиент производит их оплату по дополнительно выставленным Исполнителем
        счетам.
      </p>
      <p style="text-align: justify">
        4.8. Работы и услуги, выполняемые Исполнителем по требованию Клиента, и
        не предусмотренные настоящим Договором, оплачиваются Клиентом по
        дополнительному соглашению сторон.
      </p>
      <p class="subtitle">5. Ответственность Сторон</p>
      <p style="text-align: justify">
        5.1. Клиент несет материальную ответственность за простой автомашины,
        произошедшей по вине Клиента, Исполнителю под погрузкой или разгрузкой
        свыше {{ doc.delay_abroad_term }}} рабочих дней при международной
        перевозке и {{ doc.delay_home_term }} рабочих дней при
        внутриреспубликанской перевозке, за каждые последующие полные и неполные
        сутки в размере:
      </p>
      <ul>
        <li>
          {{ doc.customer_cis_delay_amount }} тенге на территории стран ближнего
          зарубежья (СНГ);
        </li>
        <li>
          {{ doc.customer_eu_delay_amount }} тенге на территории стран дальнего
          зарубежья (Евросоюз).
        </li>
      </ul>
      <p style="text-align: justify">
        5.2. Исполнитель в случае несвоевременной подачи автомашины под погрузку
        в определенный сторонами срок, несет перед Клиентом материальную
        ответственность в размере:
      </p>
      <ul>
        <li>
          {{ doc.courier_cis_delay_amount }} тенге на территории стран ближнего
          зарубежья (СНГ);
        </li>
        <li>
          {{ doc.courier_eu_delay_amount }}тенге на территории стран дальнего
          зарубежья (Евросоюз).
        </li>
      </ul>
      <p style="text-align: justify">
        5.3. В случае отказа Исполнителя от согласованной Заявки, Исполнитель
        выплачивает Клиенту штрафную неустойку в размер
        {{ doc.courier_declination_percent }} % от общей стоимости фрахта.
      </p>
      <p style="text-align: justify">
        5.4. За просрочку в оплате счетов Клиент уплачивает Исполнителю пеню в
        размере {{ doc.penalty_percent }}% от общей суммы платежа за каждый
        просроченный день, но не более {{ doc.penalty_never_more }} % от суммы
        задолженности.
      </p>
      <p style="text-align: justify">
        5.5. Клиент обязан возмещать документально обоснованные расходы
        Исполнителя, возникшие из-за ненадлежащего оформления Клиентом
        товарно-транспортных и иных документов.
      </p>
      <p style="text-align: justify">
        5.6. В случае отказа Клиента от согласованной перевозки на основании
        Заявки, Клиент выплачивает Исполнителю неустойку в размере
        {{ doc.customer_declination_percent }} % от общей стоимости фрахта.
      </p>
      <p style="text-align: justify">
        5.7. Уплата любой их сторон штрафных неустоек и пени не освобождает от
        выполнения принятых по Договору обязательств в надлежащем качестве и
        возмещение причиненного ущерба в полном объеме.
      </p>
      <p style="text-align: justify">
        5.8. Сторона, нарушившая свои обязательства по Договору, должна
        устранить их в кратчайшие сроки.
      </p>
      <p style="text-align: justify">
        5.9. Исполнитель несет полную ответственность за сохранность груза после
        его принятия к перевозке и до выдачи Клиенту.
      </p>
      <p style="text-align: justify">
        5.10. Исполнитель не несет ответственности за Груз и посторонние
        вложения в транспортное средство, не заявленные в Заявке и иных
        документах.
      </p>
      <p style="text-align: justify">
        5.11. После прибытия Исполнителя в пункт назначения, и передачи Груза в
        соответствии с Заявкой, накладными и иными документами, составляется
        соответствующий Акт приема-передачи, с подписанием акта водителем и
        Получателем, либо его уполномоченным лицом. Также в 24 графе СМР либо
        ТТН делается отметка о принятии груза, что говорит о том, что груз
        принят без претензий и нареканий в сторону Исполнителя.
      </p>
      <p style="text-align: justify">
        5.12. В случаях отказа Получателя принять груз по причинам, не зависящим
        от Исполнителя или в случае возврата таможенными органами груза по
        причине неверных сопроводительных документов или несоответствии по
        грузу, груз переадресовывается другому грузополучателю или возвращается
        Отправителю. В этих случаях стоимость перевозки груза в оба конца, а
        также штраф за простой автотранспортного средства оплачиваются Клиентом.
        Грузополучатель или Отправитель извещает Исполнителя об отказе от приема
        груза, производит в товарно-транспортной накладной отметку об отказе в
        приеме груза. В случае отказа грузополучателя от извещения
        грузоотправителя и проставления отметки в товарно-транспортной
        накладной, указанные действия производятся Исполнителем.
      </p>
      <p style="text-align: justify">
        5.13. При наступлении страхового случая Исполнитель обязан возместить
        ущерб, вызванный полным или частичным повреждением груза и убытки
        Клиента, связанные с повреждением и не доставкой груза. Основанием для
        расчета суммы ущерба является Инвойс Отправителя. После оплаты суммы
        ущерба Исполнитель имеет право на владение испорченным товаром.
      </p>
      <p style="text-align: justify">
        5.14. Акт считается принятым и подписанным, если в течение
        {{ doc.act_term }} рабочих дней не поступило письменной претензии о
        ненадлежащем исполнении услуг от Получателя груза.
      </p>
      <p class="subtitle">6. Форс – мажор</p>
      <p style="text-align: justify">
        6.1. При наступлении обстоятельств невозможности полного или частичного
        исполнения любой из Сторон своих обязательств по настоящему Договору,
        включая, но не ограничиваясь: стихийное бедствие, войны или военные
        действия любого характера, блокады, кроме случаев, когда до момента
        наступления указанных обстоятельств имелась задолженность Клиента по
        оплате услуг Исполнителя, срок исполнения обязательств отодвигается
        соразмерно времени, в течение которого будут действовать такие
        обстоятельства.
      </p>
      <p>
        6.2. Если такие обстоятельства будут продолжаться свыше
        {{ doc.repeats_term }} календарных дней, то каждая из Сторон имеет право
        отказаться от дальнейшего исполнения обязательств по настоящему
        Договору, и в этом случае ни одна из Сторон не будет иметь право на
        возмещение другой Стороной возможных убытков.
      </p>
      <p style="text-align: justify">
        6.3. Сторона, для которой создалась невозможность исполнения
        обязательств по настоящему Договору, обязана незамедлительно, но не
        позднее {{ doc.force_major_term }} календарных дней со дня наступления
        форс-мажорных обстоятельств, известить другую Сторону.
      </p>
      <p class="subtitle">7. Рассмотрение споров</p>
      <p style="text-align: justify">
        7.1. Настоящий Договор регулируется и толкуется в соответствии с
        законодательством Республики Казахстан.
      </p>
      <p style="text-align: justify">
        7.2. Все споры и разногласия, которые могут возникнуть из настоящего
        договора или в связи с ним, стороны будут стремиться урегулировать путем
        переговоров или в претензионном порядке. Срок рассмотрения претензий –
        {{ doc.claim_term }} рабочий день от даты получения претензии.
      </p>
      <p style="text-align: justify">
        7.3. В случае возникновения разногласий по настоящему Договору или по
        Дополнительным соглашениям к нему Стороны предпримут все меры для
        урегулирования спорных вопросов путем проведения переговоров. В случае
        если путем переговоров и взаимных уступок единство мнений достигнуто не
        будет, спор подлежит разрешению в {{ doc.resolve_term }}.
      </p>
      <p class="subtitle">8. Соглашение о конфиденциальности</p>
      <p style="text-align: justify">
        8.1. Стороны соглашаются добросовестно хранить коммерческие, финансовые
        и иные интересы другой стороны, без необходимости не разглашать и не
        передавать третьей стороне любую информацию, касающуюся настоящего
        Договора, если она предварительно неизвестна третьей стороне и к ней нет
        свободного доступа на законном основании, полученную непосредственно
        через другую Сторону настоящего Договора, за исключением случаев, когда
        это сделано с письменного согласия другой Стороны, либо перечень
        сведений, разрешенных к разглашению, определен специальным письменным
        Соглашением Сторон.
      </p>
      <p style="text-align: justify">
        8.2. Конфиденциальная информация включает в себя, но не ограничивается:
      </p>
      <p>
        a) обстоятельства, имеющие деловое отношение к финансовой либо
        хозяйственной деятельности сторон;
      </p>
      <p>
        b) данные о сторонах и их должностных лицах, причастных к исполнению
        настоящего Договора;
      </p>
      <p>c) любую иную информацию, признанную Сторонами конфиденциальной.</p>
      <p style="text-align: justify">
        8.3. Раскрытие информации, признанной Сторонами конфиденциальной,
        является нарушением данного Договора и может повлечь за собой
        одностороннее расторжение Договора, независимо от того, вызвано это
        умышленными, неосторожными или самонадеянными действиями одной из
        Сторон.
      </p>
      <p style="text-align: justify">
        8.4. Настоящий пункт не распространяется на случаи, когда сведения либо
        информация на дату подписания настоящего Договора, либо в период его
        действия были или стали широко известны не по вине Сторон.
      </p>
      <p class="subtitle">9. Общие условия</p>
      <p style="text-align: justify">
        9.1. Настоящий договор вступает в силу с момента подписания и действует
        до {{ doc.contract_term }} года. Стороны договорились, что условия
        настоящего договора применяются к их отношениям, возникшим после его
        заключения. Если по истечении срока действия настоящего договора ни одна
        из сторон не уведомит другую сторону за десять дней до истечения срока
        настоящего договора о своем намерении расторгнуть (прекратить) действие
        настоящего договора, то настоящий договор считается пролонгированным еще
        один год на тех же условиях.
      </p>
      <p style="text-align: justify">
        9.2. Настоящий договор может быть изменен и дополнен только по
        соглашению сторон. Все приложения, изменения и дополнения к договору
        должны быть оформлены в письменном виде и подписаны обеими сторонами.
      </p>
      <p style="text-align: justify">
        9.3. При заключении договора Перевозчик/ Клиент обязан предоставить
        надлежащим образом заверенные копии Уставных документов.
      </p>
      <p style="text-align: justify">
        9.4. Настоящий договор может быть расторгнут по письменному соглашению
        Сторон либо по инициативе любой из сторон без объяснения причин при
        условии письменного уведомления о своем намерении не менее, чем за
        {{ doc.contract_cancel_term }} рабочих дней до планируемой даты
        расторжения договора.
      </p>
      <p style="text-align: justify">
        9.5. Договор составлен в двух экземплярах равной юридической силы.
        Договор и все документы, связанные с ним, переданные посредством
        факсимильной связи или электронной почты, приравниваются к оригинальным
        и имеют юридическую силу.
      </p>
      <p style="text-align: justify">
        9.6. В Договоре изложены все договоренности и соглашения Сторон
        относительно его условий, при этом Соглашение заменяет все предыдущие
        письменные и устные договоренности и соглашения, касающиеся его условий.
      </p>
      <p style="text-align: justify">
        9.7. Стороны обязаны незамедлительно информировать друг друга обо всех
        существенных изменениях в правовом статусе.
      </p>
      <p class="subtitle">
        10. Юридические адреса и банковские реквизиты Сторон:
      </p>
      <div class="table" style="">
        <table
          border="1"
          cellpadding="10"
          cellspacing="0"
          width="100%"
          style="border-style: solid"
        >
          <tr>
            <td>
              <strong>Продавец:</strong><br />
              {{ doc.org1.organizations.org_name }},<br />
              {{ doc.org1.org_residency.display_text }}<br />
              {{ doc.org1.organizations.post_address }}<br />
              {{ doc.org1.organizations.company_ceo }}
            </td>
            <td>
              <strong>Покупатель:</strong><br />
              {{ doc.org2.organizations.org_name }},<br />
              {{ doc.org2.org_residency.display_text }}<br />
              {{ doc.org2.organizations.post_address }}<br />
              {{ doc.org2.organizations.company_ceo }}
            </td>
          </tr>
          <tr>
            <td><strong>От Продавца:</strong><br /></td>
            <td><strong>От Покупателя:</strong><br /></td>
          </tr>
        </table>
      </div>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/ru";
var QRCode = require("qrcode");
export default {
  name: "transport_contract",
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {
      org1_type: "",
      org1_name: "",
      org1_ceo: "",
      org1_residency: "",
      org1_address: "",
      org1_code: "",

      org2_type: "",
      org2_name: "",
      org2_ceo: "",
      org2_residency: "",
      org2_address: "",
      org2_code: "",

      city: "", // no way to get

      conditions: {
        days_to_change_price: "",
        prepayment_percent: "",
        number_of_days_for_prepayment: "",
        prepayment_percent: "",
        number_of_days_for_fullpayment: "",
        shipping_term: "",
        total_delivery_time: "",
        days_to_receive_goods: "",
        days_to_quality_receive_goods: "",
        guaranty_term: "",
        notification_term: "",
        notification_term: "",
        payment_overdue: "",
        shipping_term: "",
        shipping_overdue: "",
        arbitrage_country: { display_text: "" },
        contract_language: { display_text: "" },
        contract_term: "",
        notification_term: "",
      },

      // delivery_terms: '',
      goods_origin: "",
      delivery_from: "",
      delivery_address: "",
      courier_org_name: "",
      // contract_currency: '',
      contract_total: 0,
      contract_total_textual: "",
      delivery_country: "",

      оrganizations: {},
      xml: "",
      ecp_storage: "",
      document_number: "-",
      invoice: {},
      currencies: [],
      buyer: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
      seller: {
        organizations: {
          org_name: "",
        },
        persons: {
          given_name: "",
          last_name: "",
          position: "",
          post_address: "",
          country: "",
          person_phone_number: "",
          org_code: "",
        },
        org_residency: {
          display_text: "",
        },
      },
    };
  },
  mounted() {
    // moment.locale(this.i18n.locale=='cn'?'zh-cn':'ru', this.i18n.locale=='cn'?zh:ru);
    moment.locale("ru");
    //this.$root.$emit('print-pdf', {signature: '', type: 'transport_contract'})
    axios
      .get(
        window.base +
          "/contract/LoadCourierContractSignature?contract_id=" +
          this.doc_id,
      )
      .then((response) => {
        if (typeof response.data.signature !== "undefined") {
          // console.log("as")
          if (response.data.signature == "") {
            this.$root.$emit("print-pdf", {
              signature: "",
              type: "transport_contract",
            });
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.contracts.no-signature-message"),
              timeout: 5000,
            }).show();
          } else {
            var canvas = QRCode.toCanvas(response.data.signature, {
              width: 100,
              height: 100,
            });
            canvas.then((r) => {
              // this.check_signature(value, ()=>{
              this.$root.$emit("print-pdf", {
                signature: r,
                type: "transport_contract",
              });
              new Noty({
                theme: "light",
                type: "success",
                text: this.$t("message.contracts.yes-signature-message"),
                timeout: 5000,
              }).show();
              // window.webSocket.removeEventListener('message', {})
              // })
            });
          }
        } else {
          // console.log("bs")
          this.$root.$emit("print-pdf", {
            signature: "",
            type: "transport_contract",
          });
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.no-signature-message"),
            timeout: 5000,
          }).show();
        }
      });
  },
  methods: {
    /**
     * proxy to call external function in template
     */
    number_to_letters(val) {
      if (this.$i18n.locale == "en") return window.number_to_letters_en(val);
      else return window.number_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    days_to_letters(val) {
      if (this.$i18n.locale == "en") return window.days_to_letters_en(val);
      else return window.days_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    money_letters(val, cur) {
      if (this.$i18n.locale == "en") return window.money_letters_en(val, cur);
      else return window.money_letters(val, cur);
    },
    /**
     * proxy to call external function in template
     */
    percent_to_letters(val) {
      if (this.$i18n.locale == "en") return window.percent_to_letters_en(val);
      else return window.percent_to_letters(val);
    },
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios
        .post(window.base + "/contract/CheckCourierContractSignature", fd)
        .then((r) => {
          if (r.data == "False") {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t(
                "message.message.document_signature_is_wrong",
              ),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.document_signature_is_ok"),
              timeout: 5000,
            }).show();
            callback();
          }
        });
    },
    callback(r) {
      if (r.code == "200") {
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "contract" });
            window.webSocket.removeEventListener("message", {});
          });
        });
      }
    },
    getOrganizationAddress(org) {
      if (org.addresses[0] != null)
        return (
          org.org_residency.display_text +
          ", " +
          org.addresses[0].post_addr_district +
          ", " +
          org.addresses[0].post_addr_streethouse +
          " " +
          org.addresses[0].post_addr_house
        );
      return "";
    },
    getCity(org) {
      if (org.addresses[0] != null) return org.addresses[0].post_addr_city;
      return "";
    },
  },
  watch: {},
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    contract_currency() {
      return this.doc.attis_contract_currency.display_text;
    },
    contract_currency_code() {
      return this.doc.attis_contract_currency.value;
    },
    delivery_terms() {
      return (
        '"' +
        this.doc.attis_contract_delivery_term.value +
        ": " +
        this.doc.attis_contract_delivery_term.display_text +
        '"'
      );
    },
    day() {
      return moment(this.doc.attis_contract_date).format("D");
    },
    month() {
      return moment(this.doc.attis_contract_date).format("MMMM");
    },
    year() {
      return moment(this.doc.attis_contract_date).format("Y");
    },
    date() {
      return moment().format("D.MM.Y");
    },
    document_date() {
      // this.doc.attis_contract_create_date
    },
    currency() {
      var c = "";
      if (typeof this.invoice.CurrencyCode !== "undefined")
        this.currencies.forEach((item) => {
          if (item.value == this.invoice.CurrencyCode.trim()) {
            c = item.display_text;
          }
        });
      return c;
    },
  },
};
</script>
<style scoped>
.title:not(h1) {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  font-size: 1.2em;
}
.subline {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.subtitle {
  text-align: center;
  font-weight: bold;
}
</style>
